export default __webpack_public_path__ + "static/media/menu.0384c0e1.svg";